<template>
  <el-dialog
    title="添加联系人"
    :visible="value"
    width="90%"
    @close="handleClose"
    @open="onOpen"
    :close-on-click-modal="false"
    :append-to-body="true"
  >
    <div class="add-contact">
      <el-table
        ref="multipleTable"
        :data="tableList"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        row-key="id"
      >
        <el-table-column type="selection" width="35" reserve-selection>
        </el-table-column>
        <el-table-column label="成员名称">
          <template slot-scope="{ row }">
            <div class="member-name">
              <img :src="row.avatar" class="avatar" /> {{ row.name }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="昵称" prop="nickname"> </el-table-column>
        <el-table-column label="职位" prop="job"> </el-table-column>
        <el-table-column label="经历" prop="experience"> </el-table-column>
        <el-table-column label="项目" prop="projectIntro"> </el-table-column>
        <el-table-column label="负责岗位" prop="duty"> </el-table-column>
        <el-table-column label="手机" prop="tel"> </el-table-column>
        <el-table-column label="邮箱" prop="email"> </el-table-column>
        <el-table-column label="微信" prop="wx"> </el-table-column>
      </el-table>
      <div class="pagination_con">
        <el-pagination
          @current-change="pageChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          background
          layout="prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <div slot="footer">
      <el-button plain @click="handleClose">关闭</el-button>
      <el-button type="primary" @click="handleConfirm">添加</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { companyMemberList } from "@/assets/js/request";
export default {
  name: "AddContact",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      tableList: [],
      selectList: [],
      total: 0,
    };
  },
  computed: {
    paramsId() {
      return this.$store.state.paramsId;
    },
  },
  watch: {},
  methods: {
    handleClose() {
      this.$refs.multipleTable.clearSelection();
      this.$emit("input", false);
    },
    onOpen() {
      this.getCompanyMemberList();
    },
    async getCompanyMemberList() {
      try {
        const params = {
          companyId: this.paramsId.companyId,
          pageNum: this.currentPage,
          pageSize: this.pageSize,
        };
        const res = await companyMemberList(params);
        if (res.code !== 200) throw new Error(res.msg);

        this.tableList = res.data.rows;
        this.total = res.data?.total;
      } catch (e) {}
    },
    pageChange(index) {
      this.currentPage = index;
      this.getCompanyMemberList();
    },
    handleConfirm() {
      this.$emit("addContact", this.selectList);
      this.handleClose()
    },
    handleSelectionChange(list) {
      this.selectList = list;
    },
  },
};
</script>

<style scoped lang="scss">
.add-contact {
  .member-name {
    display: flex;
    align-items: center;
    .avatar {
      width: 22px;
      height: 22px;
      margin-right: 8px;
    }
  }
  .pagination_con {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
  }
  ::v-deep .el-table th.el-table__cell {
    background: #f2f3f5 !important;
  }
  ::v-deep .el-table {
    border: 1px solid #e5e6eb !important;
    border-bottom: none !important;
  }
}
</style>
